import { MyField } from "../../components/types";
import { Field } from "../../utils/Field";
import { DeleteButton, EditButton, WrapperField } from "react-admin";
import { MyList } from "../../components/MyList";
import MyCreate from "../../components/MyCreate";
import MyEdit from "../../components/MyEdit";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import React from "react";

const fields: MyField[] = [
  Field.text({
    label: "ID",
    source: "id",
    isCreate: false,
    isUpdate: false,
    isEdit: false,
    isFilter: false,
  }),
  Field.text({
    label: "机器人key",
    source: "botKey",
    isRequired: true,
    isFilter: false,
  }),
  Field.editNumber({
    label: "管道id",
    source: "channelId",
    isFilter: false,
  }),
  Field.text({
    label: "备注",
    source: "desc",
    isFilter: false,
  }),
  Field.dateTime({
    label: "创建时间",
    source: "createdDate",
  }),
  Field.dateTime({
    label: "更新时间",
    source: "updateDate",
  }),
];

const resource = {
  list: () => {
    return (
      <MyList
        pagination={false}
        fields={fields}
        rowActions={[<EditButton />, <DeleteButton />]}
        tableActions={
          <WrapperField>
            <EditButton />
            <DeleteButton />
          </WrapperField>
        }
        // groupingColDef={groupingColDef}
      />
    );
  },
  create: () => {
    return <MyCreate fields={fields} />;
  },
  edit: () => {
    return <MyEdit fields={fields} />;
  },
  icon: PhotoLibraryIcon,
};

export default resource;
